import { render, staticRenderFns } from "./SingleItemBundle.vue?vue&type=template&id=605aaeb7&"
import script from "./SingleItemBundle.vue?vue&type=script&lang=js&"
export * from "./SingleItemBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/9735/119/casaPadrino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605aaeb7')) {
      api.createRecord('605aaeb7', component.options)
    } else {
      api.reload('605aaeb7', component.options)
    }
    module.hot.accept("./SingleItemBundle.vue?vue&type=template&id=605aaeb7&", function () {
      api.rerender('605aaeb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SingleItemBundle.vue"
export default component.exports